import React from 'react';
import styled from 'styled-components';
const List = styled.ul `
  display: grid;
  grid-auto-flow: column;
  grid-gap: 1.125rem;
  text-decoration: none;
  align-items: center;
  margin-left: 0.5rem;
`;
export const MobileOnlyNavigation = ({ children }) => (React.createElement(List, null, children));
